export default __webpack_public_path__ + "static/media/Ballroll_00116.95d51d56.png";